import { render } from "./myButton.vue?vue&type=template&id=0be90b32&scoped=true"
import script from "./myButton.vue?vue&type=script&lang=js"
export * from "./myButton.vue?vue&type=script&lang=js"

import "./myButton.vue?vue&type=style&index=0&id=0be90b32&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be90b32"]])

export default __exports__